import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BaseAssigned } from '../../models/models';
import { GetDataService } from '../../services/getdata.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {
  @ViewChild('switchModalBtn') switchModalBtn:any;


  baseAssigned:BaseAssigned[]=[];
  currentBase:{id:number,name:string}={id:-1,name:''};
  constructor(private router:Router, private getDataService:GetDataService,
    private ngxService:NgxUiLoaderService,private cookieService:CookieService) {
    this.getDataService.getBaseAssigned().subscribe(response=>{
      this.baseAssigned = [];
      if(response){
        this.baseAssigned = response;
        console.log('base assigned==',this.baseAssigned);
      }
    },
    error=>{
      this.baseAssigned = [];
    });
    this.getDataService.getCurrentBase().subscribe(res=>{
      this.currentBase = res;
    })
    const currentBase = this.cookieService.get('currentBase');
    if(!currentBase){
      setTimeout(() => {
        this.switchModalBtn.nativeElement.click();
      }, 100);
    }
  }

  ngOnInit(): void {
  }


  adminRoute = ()=>{
    this.router.navigateByUrl("");
  }
  farmRoute = ()=>{
    this.router.navigateByUrl("/farm");
  }
  warehouseRoute = ()=>{
    this.router.navigateByUrl("/warehouse");
  }

  onUpdateBase=(baseId:number,baseName:string)=>{
    this.ngxService.start();
    this.getDataService.updateCurrentBase(baseId).subscribe(response=>{
      if(response && response.status_code && response.status_code == 200){
        this.currentBase.id = baseId;
        this.currentBase.name = baseName;
        this.cookieService.set('currentBase',JSON.stringify({id:this.currentBase.id,name:this.currentBase.name}));
        this.getDataService.setCurrentBase({id:this.currentBase.id,name:this.currentBase.name});
        window.location.reload();
      }
      this.ngxService.stop();
    },error=>{
      this.ngxService.stop();
      console.log('error',error);
    })
  }
}
